// Random photos for the Photos panel
export interface UnsplashPhoto {
  id: string;
  url: string;
  photographer: string;
  title: string;
}

// Move this to DB instead of storing here and fetch from metadata API 
export const unsplashPhotos: UnsplashPhoto[] = [
  {
    id: '1',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Mountain landscape',
  },
  {
    id: '2',
    url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=300&fit=crop',
    photographer: 'Toa Heftiba',
    title: 'Ocean waves',
  },
  {
    id: '3',
    url: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Forest path',
  },
  {
    id: '4',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Snowy mountains',
  },
  {
    id: '5',
    url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop',
    photographer: 'Omar Lopez',
    title: 'Portrait',
  },
  {
    id: '6',
    url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=300&fit=crop',
    photographer: 'Toa Heftiba',
    title: 'Beach sunset',
  },
  {
    id: '7',
    url: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Green forest',
  },
  {
    id: '8',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Mountain peak',
  },
  {
    id: '9',
    url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop',
    photographer: 'Omar Lopez',
    title: 'Person smiling',
  },
  {
    id: '10',
    url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=300&fit=crop',
    photographer: 'Toa Heftiba',
    title: 'Coastal view',
  },
  {
    id: '11',
    url: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Autumn leaves',
  },
  {
    id: '12',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Alpine scenery',
  },
  {
    id: '13',
    url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop',
    photographer: 'Omar Lopez',
    title: 'Headshot',
  },
  {
    id: '14',
    url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=300&fit=crop',
    photographer: 'Toa Heftiba',
    title: 'Sea breeze',
  },
  {
    id: '15',
    url: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Nature trail',
  },
  {
    id: '16',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Mountain vista',
  },
  {
    id: '17',
    url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop',
    photographer: 'Omar Lopez',
    title: 'Face portrait',
  },
  {
    id: '18',
    url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=300&fit=crop',
    photographer: 'Toa Heftiba',
    title: 'Ocean horizon',
  },
  {
    id: '19',
    url: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Forest canopy',
  },
  {
    id: '20',
    url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop',
    photographer: 'Ales Krivec',
    title: 'Peaks and valleys',
  },
];

